import { render, staticRenderFns } from "./certicalidad.vue?vue&type=template&id=50d57c2a"
import script from "./certicalidad.vue?vue&type=script&lang=js"
export * from "./certicalidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports